import styles from './dette-trenger-du.module.css'
import babylistaLogo from './../../public/babylista-logo.png';
export default function Sjekliste() {
	return (
		<main>
			<article className={styles.section} style={{background: 'none'}}>
				<h1>Sjekkliste - Hva trenger man?</h1>
				<p>
					Når man venter en baby, er det mye å tenke på og forberede. For å gjøre overgangen til foreldreskapet litt enklere, 
					har vi laget en liste over det viktigste du trenger for å ta vare på den lille. Enten du er førstegangsforelder eller 
					trenger en oppfriskning, vil denne listen hjelpe deg med å sørge for at du har alt på plass før babyen kommer. 
					Fra nødvendigheter til soveplassen, til de små tingene som gjør hverdagen lettere - her finner du alt du trenger for å føle deg 
					forberedt på den nye tilværelsen som forelder.
				</p>
				<div className={styles.articleLayout}>
					<div>
						<h2>Generelt</h2>
						<ul>
							<li>Stelleveske</li>
							<li>Brystpumpe</li>
							<li>Flasker og smokker</li>
							<li>Noen bodyer, både korte og langermede</li>
							<li>Sparkedresser</li>
							<li>Strømpebukser</li>
							<li>Pysjamaser</li>
							<li>Sovepose</li>
							<li>Smekker</li>
							<li>Bæresele</li>
						</ul>
					</div>
					<div>
						<h2>Soverom</h2>
						<ul>
							<li>Sengetøy</li>
							<li>Seng</li>
							<li>Tisselaken</li>
							<li>Uro</li>
							<li>Sengekant</li>
						</ul>
					</div>
					<div>
						<h2>Baderom</h2>
						<ul>
							<li>Stellematte</li>
							<li>Babysjampo</li>
							<li>Babyolje</li>
							<li>Febertermometer</li>
							<li>Kluter</li>
							<li>Badeolje</li>
							<li>Badestøtte</li>
							<li>Håndkle i myk bomull</li>
							<li>Neglesett</li>
							<li>Nesesuger</li>
						</ul>					
					</div>
					<div>
						<h2>Vogn og diverse tilbehør</h2>
						<ul>
							<li>Barnevogn</li>
							<li>Stelleveske</li>
							<li>Koppholder</li>
							<li>Mygg og regntrekk</li>
							<li>Vognpose vår</li>
							<li>Vognpose vinter</li>
							<li>Vognunderlag</li>
							<li>Refleks</li>
							<li>Solskjerm</li>
						</ul>
					</div>
					<div>
						<h2>Sommer og vårbaby</h2>
						<ul>
							<li>Kortermede bodyer</li>
							<li>Tynn lue</li>
							<li>Solkrem</li>
							<li>Solhatt</li>
							<li>Tynne sokker</li>
						</ul>
					</div>
				</div>
					<p style={{fontSize: '12px'}}>
						Denne listen tar utgangspunkt i liste fra Barnevognhuset i Oslo, og justert etter erfaring.
					</p>				
				<h2>Andre tips.</h2>
				<p>
					Hos diverse apoteker som Apotek 1, Vitusapotek og Boots kan du få en gratis babyboks.<br/>
					I tillegg så får man kjøpe en batch med våtserviette og tørrservietter til baby hos Apotek1 og Vitus apotek, 
					som kommer godt med. Dette er et bedre alternativ enn å handle i vanlig butikk
				</p>
			</article>
			<article className={styles.section}>
				<img src={babylistaLogo.src} className={styles.logo} alt="Babylista logo" style={{height: '42px', float: 'left'}}/><h2>Babylista.no</h2>
				Babymoon har inngått et samarbeid med <a href="https://www.babylista.no/" rel="nofollow" target="_blank">Babylista.no</a>
				&nbsp;som er en tjeneste som hjelper deg med å lage en liste over hva du trenger til babyen.
			</article>	
		</main>
	)
}